import React from "react";
import { colors } from "~/utils/colors";
import { breakPoints } from "~/utils/variables";

type Props = {
  children: React.ReactNode;
  to: string;
  target?: string;
};

export const StyledLink: React.FC<Props> = ({ children, to, target = "_blank" }) => {
  return (
    <>
      <style jsx>{`
        a {
          text-decoration: none;
        }
        a:link,
        a:visited,
        a:active {
          color: ${colors.orange};
        }
        a:hover {
          text-decoration: underline;
        }
        @media (${breakPoints.sp}) {
        }
      `}</style>
      <a href={to} target={target} rel={target === "_blank" ? "noopener" : undefined}>
        {children}
      </a>
    </>
  );
};
